import React, { Component } from 'react';
import './AdminFAQ.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import CreateFAQ from '../Components/CreateFAQ/CreateFAQ';
import searchicon from '../../../image/searchicon.svg'
import { Link } from 'react-router-dom';
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
import HandleRes from '../../Components/HandleRes/HandleRes';

class AdminFAQ extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            search:'',
            questionEN: '',
            answerEN: '',
            questionAR: '',
            answerAR: '',
            questionENError : "",
            answerENError: "",
            questionARError: "",
            answerARError: "",
            doneEdit: false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,

        }
        this.getFAQs = this.getFAQs.bind(this)
        this.getFAQs()
    }
    getFAQs = () => {
        const Token = localStorage.getItem("AdminTokenKayn")

        axios.get(`${LinkAPI}/api/admin/getFAQs`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                data: res.data.reverse(),
                networkError: false,
                errordatamessage: false,
                hasError: false,
            })
        }).catch(error => {
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                window.location.replace("/Admin/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext: error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });

    }


    validate = () => {
        let questionENError = "";
        let answerENError = "";
        let questionARError = "";
        let answerARError = "";

        if (this.state.questionEN.length < 2) {
            questionENError = "Type your question";
        }
        if (this.state.answerEN.length < 2) {
            answerENError = "Type your answer";
        }
        if (this.state.questionAR.length < 2) {
            questionARError = "Type your question";
        }
        if (this.state.answerAR.length < 2) {
            answerARError = "Type your answer";
        }
        if (questionENError || answerENError || questionARError || answerARError) {
            this.setState({ questionENError, answerENError, questionARError, answerARError });
            return false;
        }
        return true;
    };
    newFAQ = event => {
        event.preventDefault();
        const { questionEN, questionAR, answerEN, answerAR } = this.state
        const Token = localStorage.getItem("AdminTokenKayn")
        const isValid = this.validate();
        if (isValid) {
            axios.post(`${LinkAPI}/api/admin/newFAQ`, {
                title: {
                    en: questionEN,
                    ar: questionAR
                }
                ,
                answer: {
                    en: answerEN,
                    ar: answerAR
                }
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }).then(res => {
               
                this.setState({
                    doneEdit: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                    questionEN: '',
                    answerEN: '',
                    questionAR: '',
                    answerAR: '',
                    questionENError : "",
                    answerENError: "",
                    questionARError: "",
                    answerARError: "",
                })
                this.getFAQs()
                setTimeout(() => {
                    this.setState({
                        doneEdit: false
                    })
                }, 2000);
            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    window.location.replace("Admin/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        titleError: '',
                        onlineError: '',
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    }
    render() {
        const  filteredContantsname = this.state.data.filter(
            (contact)=>{
                return contact.title.en.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        const itemdatatabel = filteredContantsname.map((x, i) => {
            return <div className="border-bottom item-table" key={i} >
                <Link to={"/Admin/FAQ/Edit/" + x._id} className="d-block p-3  pointer">{x.title.en}</Link>
            </div>
        })
        return (
            <div>
                <div className="AppEN row   mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminFAQ Admin col-md-11 px-4">
                        <AdminHeaderTool />
                        <div className="row">
                            <h3 className="col-12 fontsize9 my-0 order-8 order-md-2" >FAQs</h3>
                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                                <div className="tableDetails border shadow mx-auto">
                                    <div className="thead-light fontsize12 text-muted">
                                        <div className="form-group has-search   ">
                                            <input type="text" className="form-control badge-pill" placeholder="Search" value={this.state.search} name="search" onChange={this.handleChange}/>
                                            <img className="ml-2 mt--9 searchiconorders" src={searchicon} alt="search" />

                                        </div>
                                        <div className="headertable p-3 border">
                                            <p className="m-0">ORDER BY DATE</p>
                                        </div>
                                    </div>
                                    <div className="fontsize12">
                                        
                                        {itemdatatabel}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 px-4 py-3 order-5">
                                <div className="picbg">
                                    <CreateFAQ state={this.state} handleChange={this.handleChange} newFAQ={this.newFAQ} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {(this.state.doneEdit ? <HandleRes title="FAQ saved successfully" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminFAQ;